import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';
import { ProductColor } from '@aloft/toolkit-sui';

export const getColorFromAdjustment = (adjustment?: AloftPrice): ProductColor => {
  if (isUndefined(adjustment)) return 'textPrimary';

  const numeric = adjustment.toNumericPrice();

  return numeric > 0 ? 'alertSuccess' : 'alertError';
};
